import './StarShow.less';

export const prefix = 'bm-c-star-show';

export { default } from './StarShow';
